"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateAndAverageFeedbacks = exports.aggregateFeedbacks = exports.FeedbackValidator = exports.FeedbackFrequencyValues = exports.FeedbackFrequency = exports.FeedbackState = void 0;
const index_1 = require("../index");
const util_1 = require("../util");
var FeedbackState;
(function (FeedbackState) {
    FeedbackState["Created"] = "created";
    FeedbackState["Active"] = "active";
    FeedbackState["Completed"] = "completed";
})(FeedbackState = exports.FeedbackState || (exports.FeedbackState = {}));
var FeedbackFrequency;
(function (FeedbackFrequency) {
    FeedbackFrequency["Daily"] = "daily";
    FeedbackFrequency["Weekly"] = "weekly";
    FeedbackFrequency["Monthly"] = "monthly";
    FeedbackFrequency["Rarely"] = "rarely";
})(FeedbackFrequency = exports.FeedbackFrequency || (exports.FeedbackFrequency = {}));
exports.FeedbackFrequencyValues = [
    FeedbackFrequency.Daily,
    FeedbackFrequency.Weekly,
    FeedbackFrequency.Monthly,
    FeedbackFrequency.Rarely,
];
exports.FeedbackValidator = util_1.generateValidator('Feedback');
function aggregateFeedbacks(feedbacks) {
    const empty = () => ({ pros: [], cons: [], rating: [] });
    const ratings = feedbacks.map((fb) => { var _a; return (_a = fb.result) === null || _a === void 0 ? void 0 : _a.ratings; }).filter((r) => !!r);
    if (ratings.length === 0)
        throw new Error('not enough ratings to aggregate feedbacks');
    const version = ratings[0].version;
    const aggregated = Object.fromEntries(index_1.DNA_VALUES.map((value) => [value, empty()]));
    const unused = new Set(index_1.DNA_VALUES);
    for (const rating of ratings) {
        if (rating.version !== version)
            throw new Error('feedbacks must have the same version within a round');
        for (const key of Object.keys(rating)) {
            if (key === 'version')
                continue;
            unused.delete(key);
            // @ts-ignore
            aggregated[key].cons.push(rating[key].cons);
            // @ts-ignore
            aggregated[key].pros.push(rating[key].pros);
            // @ts-ignore
            aggregated[key].rating.push(rating[key].rating);
        }
    }
    for (const key of [...unused]) {
        delete aggregated[key];
    }
    return [aggregated, version];
}
exports.aggregateFeedbacks = aggregateFeedbacks;
function aggregateAndAverageFeedbacks(feedbacks) {
    const [aggregated, version] = aggregateFeedbacks(feedbacks);
    const averages = {
        version,
        ...Object.fromEntries(Object.entries(aggregated).map(([key, value]) => {
            const average = value.rating.reduce((acc, cur) => acc + cur, 0) / value.rating.length;
            return [key, average];
        })),
    };
    return averages;
}
exports.aggregateAndAverageFeedbacks = aggregateAndAverageFeedbacks;
//# sourceMappingURL=feedback.js.map